export default __webpack_public_path__ + "static/media/rkdatta_image_1.f41e318d.jpeg";